module.exports = __webpack_public_path__ + "static/img/logo-NC-Pro-2x.9b62bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-NC-Pro-2x.png
// module id = MgZQ
// module chunks = 62